"use client";

import { c as _c } from "react/compiler-runtime";
import MapContainer from "@/app/[lng]/_components/map/map-container";
import { BusPartnerModalCard } from "@/app/[lng]/(mainPages)/buspartner/_components/buspartner-modal-card";
import { useTranslation } from "@/app/i18n/client";
import { MarkerType } from "@/components/Util/Map/Map";
import { Modal } from "@/components/Util/Modal";
import { useRegisteredCompaniesNearQuery } from "@/utils/tanstack-query/hooks/queries";
import { Company, CompanyType } from "@/types/company";
import { useMemo, useState } from "react";
import { useMapLocationContext } from "@/utils/contexts/map-location-context";
import { GeoLocationWithRadius } from "@/types/location";
export function BusPartnerMap() {
  const $ = _c(27);
  const {
    t
  } = useTranslation();
  const mapLocationContext = useMapLocationContext();
  let t0;
  if ($[0] !== mapLocationContext.location) {
    t0 = !!mapLocationContext.location ? [{
      radius: 100,
      location: mapLocationContext.location?.location
    } satisfies GeoLocationWithRadius] : undefined;
    $[0] = mapLocationContext.location;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const locationSearch = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["busoperator"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data
  } = useRegisteredCompaniesNearQuery(t1, locationSearch);
  let t2;
  if ($[3] !== data) {
    t2 = data?.filter(_temp);
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const busCompanies = t2;
  const [open, setOpen] = useState(false);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [companiesToShow, setCompaniesToShow] = useState(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function changedOpen(open_0) {
      if (!open_0) {
        setOpen(false);
      }
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const changedOpen = t4;
  let t5;
  if ($[7] !== data) {
    t5 = function openWithCompanies(ids) {
      setCompaniesToShow(ids.map(id => data?.find(company => company.id === id)).filter(_temp2));
      setOpen(true);
    };
    $[7] = data;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const openWithCompanies = t5;
  let t6;
  if ($[9] !== busCompanies) {
    t6 = busCompanies ?? [];
    $[9] = busCompanies;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== openWithCompanies || $[12] !== t6) {
    t7 = <MapContainer className="h-[600px]" containerClassName="h-full" showClusterModal={openWithCompanies} visibleItems={t6} type={MarkerType.Companies} hideSearchField={true} height="100%" />;
    $[11] = openWithCompanies;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("MAIN.HOMEV2.ABOUT_MATCHBUS.PARTNERS");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== companiesToShow) {
    t9 = companiesToShow.map(_temp3);
    $[16] = companiesToShow;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">{t9}</div>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== open || $[21] !== t10 || $[22] !== t8) {
    t11 = <Modal header={t8} changedOpen={changedOpen} open={open}>{t10}</Modal>;
    $[20] = open;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t7) {
    t12 = <>{t7}{t11}</>;
    $[24] = t11;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function _temp3(company_1) {
  return <BusPartnerModalCard key={`company-${company_1.id}`} company={company_1} />;
}
function _temp2(company_0) {
  return company_0 !== undefined;
}
function _temp(c) {
  return c.companyType === "busoperator";
}